"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _contentStyle = require("./content.style.js");

var _utils = require("../../style/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const marginPropTypes = (0, _utils.filterStyledSystemMarginProps)(_propTypes2.default.space);

const Content = ({
  variant = "primary",
  children,
  title,
  inline = false,
  align = "left",
  titleWidth,
  bodyFullWidth = false,
  ...rest
}) => /*#__PURE__*/_react.default.createElement(_contentStyle.StyledContent, _extends({
  align: align,
  bodyFullWidth: bodyFullWidth
}, rest, {
  "data-component": "content"
}), /*#__PURE__*/_react.default.createElement(_contentStyle.StyledContentTitle, {
  variant: variant,
  inline: inline,
  "data-element": "content-title",
  titleWidth: titleWidth,
  align: align
}, title), /*#__PURE__*/_react.default.createElement(_contentStyle.StyledContentBody, {
  variant: variant,
  inline: inline,
  "data-element": "content-body",
  bodyFullWidth: bodyFullWidth,
  titleWidth: titleWidth,
  align: align
}, children));

Content.propTypes = { ...marginPropTypes,

  /** Applies a theme to the Content Value: primary, secondary */
  variant: _propTypes.default.oneOf(["primary", "secondary"]),

  /** The body of the content component */
  children: _propTypes.default.node,

  /** The title of the content component */
  title: _propTypes.default.string,

  /** Displays the content inline with the title */
  inline: _propTypes.default.bool,

  /** Aligns the content (left, center or right) */
  align: _propTypes.default.oneOf(["left", "center", "right"]),

  /** Sets a custom width for the title element */
  titleWidth: _propTypes.default.string,

  /** Over-rides the calculation of body width based on titleWidth.
   * Sometimes we need the body to be full width while keeping a title width similar to other widths */
  bodyFullWidth: _propTypes.default.bool
};
var _default = Content;
exports.default = _default;